import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AuthCallbackPage } from '~/features/auth/pages/auth-callback-page';

const searchSchema = z
  .object({
    code: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/auth/$provider/callback')({
  validateSearch: searchSchema,
  component: AuthCallbackPage,
});
